import { render, staticRenderFns } from "./ExWxyx.vue?vue&type=template&id=742de70c&scoped=true"
import script from "./ExWxyx.vue?vue&type=script&lang=js"
export * from "./ExWxyx.vue?vue&type=script&lang=js"
import style0 from "./ExWxyx.vue?vue&type=style&index=0&id=742de70c&prod&lang=scss&scoped=true"
import style1 from "./ExWxyx.vue?vue&type=style&index=1&id=742de70c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742de70c",
  null
  
)

export default component.exports